import { getRouteParams } from './getRouteParams';
export const getFlowKey = () => {
  return getRouteParams().flowKey;
};